import TrueMatchesInfoTable from './TrueMatchesInfoTable';

export default TrueMatchesInfoTable;


// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/true-matches-info-table/index.js